import { createContext, useContext } from "react";
import type { Team, Project, Actor, UserRole } from "@vibe/shared";
export type User = Actor & {
  email: string;
  role: UserRole;
  csrf: string;
  theme: "dark" | "light";
  email_notifications: boolean;
  daily_email: boolean;
};
export const WorkspaceContext = createContext<{
  user: User;
  team: Team | null;
  project: Project | null;
  projects: Project[];
  setProject: (id: string, preserveRoute?: boolean) => void;
}>({} as any);
export const useWorkspace = () => useContext(WorkspaceContext);
